import {toast} from 'react-toastify';

export function notifySuccess(message: string) {
    toast.success(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: 'bg-success p-3'
    });
}

export function notifyError(message: string | Error) {
    if (typeof (message) !== 'string') {
        message = !message.message || message.message.includes('Network') ?
            'An error has occurred while trying to connect to the server.' : message.message;
    }
    toast.error(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: 'bg-danger p-3'
    });
}

export function notifyInformation(message: string) {
    toast.info(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: 'bg-info p-3'
    });
}

export function notifyWarning(message: string) {
    toast.warn(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: 'bg-warning p-3'
    });
}